import { filter, tap, ignoreElements } from "rxjs/operators";
import { Epic } from "redux-observable";
import { RootState } from "../../store";
import { ServiceContainer } from "../../serviceContainer";
import * as actions from "./commonActions";

export const showToastEpic: Epic<any, any, RootState, ServiceContainer> = (
  action$,
  state$,
  services
) =>
  action$.pipe(
    filter((action) => action.type === actions.SHOW_TOAST_ACTION),
    tap((action: actions.ShowToastAction) => {
      if (services.toastr[action.messageType]) {
        services.toastr[action.messageType]("", action.message);
      }
    }),
    ignoreElements()
  );
